// React
import React, { useEffect, useState } from "react";

// MUI
import {
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Paper,
} from "@mui/material";

// Formik
import { useFormik } from "formik";

//Components
import Dropzone from "components/Dropzone_one";
import TableModal from "components/TableExplanded/Table";

// import CustomDropzone from "components/Dropzone";
import { GradientShadow } from "components/GradientButton";

// Other
import { Divider } from "antd";
import Swal from "sweetalert2";
import { formatCurrency2Digit } from "utils/helpers/format";

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field ของผู้ที่มาซื้อ
const customerFields = [
  {
    label: "คำนำหน้า",
    name: "prefix",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    label: "ชื่อ-นามสกุล",
    name: "fullName",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    label: "เลขบัตรประชาชน",
    name: "idCardNumber",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    label: "เบอร์โทรศัพท์",
    name: "phoneNumber",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    label: "ที่อยู่",
    name: "address",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    label: "สัญชาติ",
    name: "nationality",
    type: "text",
    required: true,
    disabled: true,
  },
];

const ViewCustomer = ({ open, onClose, selectedProduct }) => {
  // ตัวแปรสำหรับเก็บข้อมูลรูปภาพ
  const [files1, setFiles1] = useState([]);
  const [files2, setFiles2] = useState([]);
  const [error2, setError2] = useState(null);
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  const [deletedImageIds, setDeletedImageIds] = useState([]);

  useEffect(() => {
    if (selectedProduct) {
      // console.log("selectedProduct", selectedProduct);
      formik.setValues({
        prefix: selectedProduct.prefix || "",
        fullName: selectedProduct.customer_name || "",
        idCardNumber: selectedProduct.idcard || "",
        phoneNumber: selectedProduct.customer_phonenumber || "",
        address: selectedProduct.customer_address || "",
        nationality: selectedProduct.nationality || "",
      });
    }
  }, [selectedProduct]);

  // Formik hook
  const formik = useFormik({
    initialValues: {
      //สำหรับกำหนดค่า รายละเอียดลูกค้า
      fullName: "",
      idCardNumber: "",
      phoneNumber: "",
      address: "",
    },
  });

  // ฟังก์ชันการแสดงฟิลด์ Customer
  const renderFieldsCustomer = (fields) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
          <Box display="flex" alignItems="center">
            <Typography
              variant="subtitle1"
              sx={{ width: "200px", whiteSpace: "nowrap" }}
            >
              {field.label}
              {field.required && (
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              )}
            </Typography>
            <Typography>{formik.values[field.name] || ""}</Typography>
          </Box>
        </Grid>
      </React.Fragment>
    ));
  };

  //Columns ข้อมูลเข้าไปแสดงในตาราง
  const columns = [
    { Header: "ลำดับ", accessor: "id", showInFilter: false },
    { Header: "รหัสรายการ", accessor: "order_code", showInFilter: false },
    {
      Header: "จำนวนเงิน",
      accessor: "total_price",
      showInFilter: false,
      Cell: ({ row }) => (
        <span>{formatCurrency2Digit(row?.total_price || 0)}</span>
      ),
    },
    { Header: "สถานะ", accessor: "order_status", showInFilter: false },
    { Header: "ประเภท", accessor: "order_type", showInFilter: false },
    { Header: "วันที่บันทึก", accessor: "created_date", showInFilter: false },
    { Header: "วันที่สิ้นสุด", accessor: "return_date", showInFilter: false },
  ];

  //Map ข้อมูลเข้าไปแสดงในตาราง
  const mappedData = [
    {
      id: selectedProduct?.id,
      order_code: selectedProduct?.order_code, // รหัสออร์เดอร์
      customer_name: selectedProduct?.customer_name, // ชื่อลูกค้า
      customer_phonenumber: selectedProduct?.customer_phonenumber, // เบอร์โทรศัพท์
      idcard: selectedProduct?.idcard, // เลขบัตรประชาชน
      total_price: selectedProduct?.total_price, // ราคาทั้งหมด
      order_status: selectedProduct?.order_status, // สถานะ
      created_date: selectedProduct?.created_date, // วันที่สร้าง
      updated_date: selectedProduct?.updated_date, // วันที่แก้ไข
      prefix: selectedProduct?.prefix, // คำนำหน้า
      nationality: selectedProduct?.nationality, // สัญชาติ
    },
  ];

  //กรณีปิดหน้าต่าง Modal
  const handleCancel = () => {
    const formHasUnsavedChanges = Object.keys(touched).some(
      (field) => touched[field]
    );

    // console.log('formHasUnsavedChanges', formHasUnsavedChanges);
    // Prompt the user to confirm before closing if there are unsaved changes
    if (formHasUnsavedChanges) {
      Swal.fire({
        title: "Cancel",
        text: "If you cancel now, your information fills will be discarded.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0066FF",
        cancelButtonColor: "#0066FF",
        reverseButtons: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Keep Editing",
        customClass: {
          confirmButton: "confirm-rounded-button",
          cancelButton: "outlined-button",
          container: "swal2-container-custom", // Add custom class for container
        },
        didOpen: () => {
          // Set z-index in didOpen to ensure it's applied after dialog is rendered
          document.querySelector(".swal2-container-custom").style.zIndex = 1500; // or a higher value
        },
        iconHtml:
          '<svg width="150" height="150" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.4339 0.666016C36.3209 0.666016 46.7673 11.1123 46.7673 23.9993C46.7673 36.8863 36.3209 47.3327 23.4339 47.3327C10.5469 47.3327 0.100586 36.8863 0.100586 23.9993C0.100586 11.1123 10.5469 0.666016 23.4339 0.666016ZM23.4339 5.33268C18.4832 5.33268 13.7353 7.29934 10.2346 10.8C6.73391 14.3007 4.76725 19.0486 4.76725 23.9993C4.76725 28.9501 6.73391 33.698 10.2346 37.1987C13.7353 40.6994 18.4832 42.666 23.4339 42.666C28.3846 42.666 33.1326 40.6994 36.6332 37.1987C40.1339 33.698 42.1006 28.9501 42.1006 23.9993C42.1006 19.0486 40.1339 14.3007 36.6332 10.8C33.1326 7.29934 28.3846 5.33268 23.4339 5.33268ZM23.4339 30.9993C24.0528 30.9993 24.6462 31.2452 25.0838 31.6828C25.5214 32.1203 25.7673 32.7138 25.7673 33.3327C25.7673 33.9515 25.5214 34.545 25.0838 34.9826C24.6462 35.4202 24.0528 35.666 23.4339 35.666C22.8151 35.666 22.2216 35.4202 21.784 34.9826C21.3464 34.545 21.1006 33.9515 21.1006 33.3327C21.1006 32.7138 21.3464 32.1203 21.784 31.6828C22.2216 31.2452 22.8151 30.9993 23.4339 30.9993ZM23.4339 9.99935C24.0528 9.99935 24.6462 10.2452 25.0838 10.6828C25.5214 11.1204 25.7673 11.7138 25.7673 12.3327V26.3327C25.7673 26.9515 25.5214 27.545 25.0838 27.9826C24.6462 28.4202 24.0528 28.666 23.4339 28.666C22.8151 28.666 22.2216 28.4202 21.784 27.9826C21.3464 27.545 21.1006 26.9515 21.1006 26.3327V12.3327C21.1006 11.7138 21.3464 11.1204 21.784 10.6828C22.2216 10.2452 22.8151 9.99935 23.4339 9.99935Z" fill="#ED4040"/></svg>',
      }).then(async (result) => {
        if (result.isConfirmed) {
          formik.resetForm();
          setFiles1([]); // Clear product images
          setFiles2([]); // Clear customer images
          setInitialProductUrls([]); // Clear initial product image URLs
          // setInitialCustomerUrls([]);
          setDeletedImageIds([]);
          onClose();
        }
      });
    } else {
      formik.resetForm();
      setFiles1([]); // Clear product images
      setFiles2([]); // Clear customer images
      setInitialProductUrls([]); // Clear initial product image URLs
      // setInitialCustomerUrls([]);
      setDeletedImageIds([]);
      onClose();
    }
  };

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        //ป้องกันการกดเบื้องหลังแล้วหลุด
        if (reason !== "backdropClick") onClose();
      }}
      disableEscapeKeyDown
      fullWidth
      maxWidth="lg"
      sx={{
        borderRadius: "8px",
      }}
    >
      <>
        {/* หน้าที่ 1 : Form */}
        <DialogTitle style={{ backgroundColor: "#F1F2F7" }}>
          <Typography variant="h4">ดูรายละเอียดลูกค้า</Typography>
        </DialogTitle>
        <DialogContent style={{ backgroundColor: "#F1F2F7" }}>
          <form onSubmit={formik.handleSubmit}>
            {/* Render the product boxes */}
            <Grid item xs={12} sx={{ mx: 2 }}>
              <Typography sx={{ mb: 1, ml: 2 }} variant="h5">
                ข้อมูลลูกค้า
              </Typography>
              <Paper sx={{ p: 2, borderRadius: "12px" }}>
                <Grid container>
                  <Grid item xs={7}>
                    {renderFieldsCustomer(customerFields)}
                  </Grid>
                  <Grid item xs={5} sx={{ mt: 2 }}>
                    {selectedProduct ? (
                      <img
                        src={selectedProduct.customer_image}
                        alt="Preview"
                        style={{
                          width: "200px",
                          height: "200px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <Dropzone
                        files={files2}
                        setFiles={setFiles2}
                        setError={setError2}
                      />
                    )}
                    {error2 && (
                      <Typography variant="caption" color="error">
                        {error2}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Paper>

              <Grid items xs={12}>
                {/* Render the product boxes */}
                <Typography sx={{ mb: 2, mt: 3, ml: 2 }} variant="h5">
                  รายการ
                </Typography>
                <TableModal
                  columns={columns}
                  data={selectedProduct?.order_items}
                />
                {/* {renderProductBoxes()} */}
              </Grid>
            </Grid>
          </form>
        </DialogContent>

        <DialogActions
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0 16px 16px 16px",
            backgroundColor: "#F1F2F7",
          }}
        >
          {/* Dialog Actions */}
          <Grid container sx={{ mx: 3 }}>
            <Grid item xs={12}>
              <Divider
                style={{
                  marginTop: "0",
                  marginBottom: "16px",
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              container
              justifyContent="space-between" // Apply flex properties to align buttons
            >
              <GradientShadow
                onClick={handleCancel}
                sx={{
                  borderRadius: "12px", // Make the button circular
                  minWidth: "150px", // Adjust the width
                  minHeight: "20px", // Adjust the height
                  padding: 0, // Remove padding to center the icon better
                  borderColor: "#c4c4c4", // Light grey border
                  color: "#6c6c6c", // Light grey icon color
                  display: "flex", // Ensure flexbox is used
                  alignItems: "center", // Center vertically
                  justifyContent: "center", // Center horizontally
                  "&:hover": {
                    borderColor: "#a0a0a0", // Darker grey on hover
                  },
                }}
              >
                กลับ
              </GradientShadow>
            </Grid>
          </Grid>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default ViewCustomer;
